import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import RightDrawer from "../../../RightDrawer";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DeviceAnalyticTimeFilterPanel = ({
  open,
  onClose,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  onApply,
  onClear,
  compareMethod,
  setCompareMethod,
}) => {
  const hasFilters = fromDate && toDate;

  return (
    <RightDrawer open={open} onClose={onClose} title="Analytics Filter">
      <Box className="flex flex-col h-full">
        {/* Content Area */}
        <Box className="p-3 border-t border-gray-300 flex-grow flex flex-col gap-3 overflow-y-auto">
          <Box sx={{ position: "relative", zIndex: 100 }}>
            <Typography variant="subtitle2" gutterBottom>
              From
            </Typography>
            <ReactDatePicker
              selected={fromDate}
              onChange={setFromDate}
              showTimeSelect
              dateFormat="Pp"
              customInput={<TextField fullWidth label="Select Date & Time" />}
              popperPlacement="bottom-start"
            />
          </Box>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              To
            </Typography>
            <ReactDatePicker
              selected={toDate}
              onChange={setToDate}
              minDate={fromDate}
              showTimeSelect
              dateFormat="Pp"
              customInput={<TextField fullWidth label="Select Date & Time" />}
              popperPlacement="bottom-start"
            />
          </Box>

          {hasFilters && (
            <>
              <Typography variant="subtitle2" gutterBottom>
                Compare Method
              </Typography>
              <Select
                fullWidth
                value={compareMethod}
                onChange={(e) => setCompareMethod(e.target.value)}
              >
                <MenuItem value="closest">Closest to Picked Time</MenuItem>
                <MenuItem value="average">Average Between Time</MenuItem>
                <MenuItem value="median">Median Between Time</MenuItem>
                <MenuItem value="min">Minimum Value</MenuItem>
                <MenuItem value="max">Maximum Value</MenuItem>
                <MenuItem value="diff">Difference (End - Start)</MenuItem>
              </Select>
            </>
          )}
        </Box>

        {/* Footer Buttons */}
        <Box className="p-3 border-t border-gray-200 flex gap-2">
          {hasFilters && (
            <Button
              variant="outlined"
              sx={{ flex: 1 }}
              className="!normal-case"
              onClick={onClear}
            >
              Clear Filter
            </Button>
          )}
          <Button
            variant="contained"
            sx={{ bgcolor: "#22C55E", color: "white", flex: 2 }}
            className="!normal-case"
            onClick={onApply}
          >
            Apply Filter
          </Button>
        </Box>
      </Box>
    </RightDrawer>
  );
};

DeviceAnalyticTimeFilterPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  setFromDate: PropTypes.func.isRequired,
  setToDate: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  compareMethod: PropTypes.string.isRequired,
  setCompareMethod: PropTypes.func.isRequired,
};

export default DeviceAnalyticTimeFilterPanel;
